// extracted by mini-css-extract-plugin
export default {"container":"CallFromDMS_container__iBOUA"};